module.exports = __webpack_public_path__ + "img/snazzy.c980654c.png";